<app-page>
  <app-page-title title="{{ 'TRAINING-CALENDAR.TITLE' | translate }}">
    <!-- <form [formGroup]="filterForm" class="flex-gap-1rem flex-center-between">
      <div class="drop-down-width">
        <app-organisation-unit-tree-drop-down
          [organisationUnits]="locations$"
          formControlName="organisationUnitLocationIds"
        >
        </app-organisation-unit-tree-drop-down>
      </div>
      <div class="drop-down-width">
        <app-training-group-drop-down
          [trainingGroups]="trainingGroups$"
          formControlName="trainingGroupIds"
        ></app-training-group-drop-down>
      </div>
    </form> -->
  </app-page-title>
  <div class="calendar-wrapper">
    <dx-scheduler
      [dataSource]="schedulerData"
      [remoteFiltering]="true"
      [(currentView)]="currentView"
      [customizeDateNavigatorText]="customizeDateNavigatorText"
      [startDayHour]="8"
      [endDayHour]="19"
      [currentDate]="schedulerCurrentDate"
      (currentDateChange)="onCurrentDateChange($event)"
      appointmentTemplate="appointment-template"
      [showAllDayPanel]="true"
      allDayPanelMode="hidden"
      [showCurrentTimeIndicator]="false"
      [firstDayOfWeek]="1"
      (onAppointmentClick)="redirectToDetailPage($event)"
      (onAppointmentRendered)="colorizeAppointments($event)"
      (onAppointmentTooltipShowing)="onTooltipShowing($event)" 
      [height]="schedulerHeight"
    >
      <dxi-view 
        type="month" 
        [maxAppointmentsPerCell]="4"
      ></dxi-view>
      <dxi-view
        type="week"
        dateCellTemplate="dateCellTemplate"
        showAllAppointmentsAtTimeCells="true"
      ></dxi-view>
      <dxi-view 
        type="agenda"
        [agendaDuration]="agendaDuration"
        [startDate]="agendaStartDate"
        appointmentTemplate="agenda-appointment-template"
      ></dxi-view>
      <!-- <dxi-view type="day" showAllAppointmentsAtTimeCells="true"></dxi-view> -->
      <dxo-editing
        #editingOptions
        [allowAdding]="false"
        [allowDeleting]="false"
        [allowUpdating]="false"
        [allowResizing]="false"
        [allowDragging]="false"
      >
      </dxo-editing>

      <div *dxTemplate="let model of 'agenda-appointment-template'">
        <div class="agenda-appointment">
          <div class="agenda-image-container" *ngIf="model.appointmentData.imageUrl">
            <img
              [src]="model.appointmentData.imageUrl | safe:'url'" 
              title="Source"
              class="agenda-image"
            />
          </div>
          <div class="agenda-content">
            <div class="agenda-title">
              {{ model.appointmentData.text }}
            </div>
            <div class="agenda-description">
              <div>{{ "COMMON.DATE" | translate }}: {{ model.appointmentData.startDate | date:'dd.MM.yyyy' }} - {{ formatTime(model.appointmentData.startDate | date : "HH:mm a") }}</div>
              <div>{{ "COMMON.FIELDS.TRAINING-TYPE" | translate }}: {{ getTrainingType(model.appointmentData.type) }}</div>
              <div>{{ "COMMON.FIELDS.LOCATION" | translate }}: {{ getTrainingLocation(model.appointmentData.location) }}</div>
            </div>
          </div>
        </div>
      </div>

      <div *dxTemplate="let model of 'appointment-template'">
        <div
          class="appointment"
          [class.expand-left]="isRightEdge(model.appointmentData)"
        >
          @if(model.appointmentData.isFromSubscribedSource) {
            <div class="source-appointment-preview">
              <div class="appointment-default">
                <span class="logo-text">
                  <strong>{{ formatTime(model.appointmentData.startDate | date : "H:mm") }}</strong>
                </span >
                <span class="appointment-desc">
                  {{ model.appointmentData.text }}
                </span>
              </div>
              <div class="appointment-hover">
                <div class="row">
                  <div class="col-auto">
                    <div class="logo-container">
                      <p class="logo-text">
                        <strong>{{ formatTime(model.appointmentData.startDate | date : "H:mm") }}</strong>
                      </p>
                      <div class="logo-image-container">
                        <img
                          [src]="model.appointmentData.sourceTenantLogoUrl | safe:'url'" 
                          title="Source"
                          class="logo-image"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col source-appointment-container">
                    <div class="appointment-desc">
                      {{model.appointmentData.sourceTenantName}} - {{ model.appointmentData.text }}
                    </div>
                    <div>
                    <div class="appointment-date">
                      {{ model.appointmentData.startDate | date : "HH:mm a" }} -
                      {{ model.appointmentData.endDate | date : "HH:mm a" }}
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="appointment-preview">
              <div class="appointment-default">
                <span class="logo-text">
                  <strong>{{ formatTime(model.appointmentData.startDate | date : "H:mm") }}</strong>
                </span >
                <span class="appointment-desc">
                  {{ model.appointmentData.text }}
                </span>
              </div>
              <div class="appointment-hover">
                <div class="row">
                  <div class="col-auto">
                    <div class="appointment-top">
                      <strong>{{ formatTime(model.appointmentData.startDate | date : "H:mm") }}</strong>
                    </div>
                  </div>
                  <div class="col">
                    <div class="appointment-desc">
                      {{ model.appointmentData.text }}
                    </div>
                      <div class="appointment-bottom">
                        {{ model.appointmentData.startDate | date : "HH:mm a" }} -
                        {{ model.appointmentData.endDate | date : "HH:mm a" }}
                      </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div *dxTemplate="let data of 'dateCellTemplate'">
        <b>{{ data.date.getDate() }}</b>
        {{
          ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][data.date.getDay()]
        }}
      </div>

      <!-- 
      //appointmentTooltipTemplate="appointmentTooltipTemplate"
      <ng-container *dxTemplate="let data of 'appointmentTooltipTemplate'">
        <a
          class="dx-tooltip-appointment-item"
          [routerLink]="['/my-trainings/training/' + data.appointmentData.id]"
        >
          <div class="dx-tooltip-appointment-item-marker">
            <div class="dx-tooltip-appointment-item-marker-body"></div>
          </div>
          <div class="dx-tooltip-appointment-item-content">
            <div class="dx-tooltip-appointment-item-content-subject">
              {{ data.appointmentData.text }}
            </div>
            <div class="dx-tooltip-date-content">
              <span class="dx-tooltip-date">
                {{
                  {
                    start: data.appointmentData.startDate,
                    end: data.appointmentData.endDate
                  } | trainingDate : translateService.currentLang
                }}
              </span>
              <span *ngIf="translateService.currentLang == 'en'">
                {{ data.appointmentData.startDate | date : "hh:mm a" }} -
                {{ data.appointmentData.endDate | date : "hh:mm a" }}
              </span>
              <span *ngIf="translateService.currentLang == 'de'">
                {{ data.appointmentData.startDate | date : "HH:mm" }} -
                {{ data.appointmentData.endDate | date : "HH:mm" }}
              </span>
            </div>
          </div>
        </a>
      </ng-container> -->
    </dx-scheduler>
  </div>
</app-page>


<dx-popup
  [(visible)]="showAppointmentsPopup"
  [width]="520"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  class="appointments-popup"
>
  <div *dxTemplate="let data of 'content'">
    <div class="popup-container">
      <h3 class="popup-header">
        {{ 'TRAINING-CALENDAR.ALL-EVENTS-ON-DATE' | translate }} {{ selectedDate | date: 'MM/dd/yyyy' }}
      </h3>

      <div *ngIf="selectedAppointments?.length === 0" class="no-appointments">
        {{ 'TRAINING-CALENDAR.NO-APPOINTMENTS' | translate }}
      </div>

      <div
        *ngFor="let appointmentData of selectedAppointments"
        class="popup-event-card"
        [ngStyle]="{
          backgroundColor: getAppointmentBgColor(appointmentData),
          color: getAppointmentTextColor(appointmentData)
        }"
      >
        <div class="popup-event-inner" (click)="onAppointmentClick(appointmentData)">
          <div class="popup-event-time-block">
            {{ formatTime(appointmentData.startDate | date: 'H:mm') }}
            @if (appointmentData.isFromSubscribedSource) {
              <div class="popup-logo-container">
                <img
                  [src]="appointmentData.sourceTenantLogoUrl | safe:'url'"
                  alt="logo"
                  class="popup-logo"
                />
              </div>
            }
          </div>

          <div class="popup-event-details">
            @if (appointmentData.isFromSubscribedSource) {
              <div class="popup-event-title">
                
                {{ appointmentData.sourceTenantName }} –
                {{ appointmentData.text }}
              </div>
            } @else {
              <div class="popup-event-title">{{ appointmentData.text }}</div>
            }

            <div class="popup-event-time-range">
              {{ appointmentData.startDate | date: 'hh:mm a' }} –
              {{ appointmentData.endDate | date: 'hh:mm a' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="center"
    [options]="{
      text: ('COMMON.CLOSE' | translate),
      onClick: onClose
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>
